var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Flex } from 'rebass';
export default function Separator(_a) {
    var _b = _a.barColor, barColor = _b === void 0 ? 'neutral_4' : _b, _c = _a.variant, variant = _c === void 0 ? 'center' : _c, props = __rest(_a, ["barColor", "variant"]);
    var ends = {
        bg: barColor,
        content: '" "',
        height: '1px',
        display: 'block',
        flex: '1 1 auto',
    };
    return (React.createElement(Flex, __assign({ variant: "separator." + variant, m: 0 }, props, { sx: {
            width: '100%',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            '&::before': ends,
            '&::after': ends,
        } })));
}
